import { PurchaseHistory, TransactionTheater } from '@/types/purchase-history';
import { format, getHours, isSameDay, isSameYear, subDays } from 'date-fns';
import { dateTimeMinTimeValue } from './date-time-helper';

const dateFnsShowtimeFormat = 'MMMM d \'at\' h:mm a';

export const formatShowtime = (showtime: Date, theater?: TransactionTheater): string => {
  if (theater == null || showtime == null)  return '';

  const now = new Date();
  let returnValue = '';

  returnValue = isSameDay(showtime, now)
    ? `Today at ${format(showtime, 'h:mm a').toUpperCase()}`
    : `${format(showtime, `EEEE, ${dateFnsShowtimeFormat}`)}`;

  if (getHours(showtime) < 6 && showtime.getTime() !== dateTimeMinTimeValue) {
    const updatedShowtime = subDays(showtime, 1);
    returnValue = `${format(updatedShowtime, 'EEEE')} Night, ${format(updatedShowtime, dateFnsShowtimeFormat)}`;
  }

  return returnValue;
};

export const formatShowtimeTimeOnly = (showtime: Date, timeZone?: string): string => {
  if (timeZone) {
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      hour12: true,
      minute: '2-digit',
      timeZone,
    }).format(showtime);
  }
  return format(showtime, 'h:mm a').toUpperCase();
};

export const formatDisplayDate = (purchase: PurchaseHistory): string => {
  return isSameDay(new Date(), purchase.showtime) ? 'Today'
    : purchase.showtime.getTime() === new Date(-8640000000000000).getTime()
      ? `${format(purchase.purchaseDate, 'EEEE, MMMM d, yyyy')}`
      : `${format(purchase.showtime, 'EEEE, MMMM d, yyyy')}`;
};

export const formatOpeningDate = (date: Date): string => {
  return isSameYear(date, new Date())
    ? format(date, 'MMM d')
    : format(date, 'MMM d yyyy');
};

export const formatArticleDate = (date: Date): string => {
  return format(date, 'MM/dd/yyyy');
};

export const getPresaleViewButtonLabel = (publicOnSaleDate?: Date): string => {
  if (!publicOnSaleDate) return 'View Details';

  const formattedDate = publicOnSaleDate.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
  });

  return `View ${formattedDate} Showtimes`;
};

export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');
  const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);

  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : digits;
};
